export const PWA_API   =  'https://bom.labsls.com/' ;
export const PWA_PROXY_API=  'https://bom.labsls.com/proxy/' ;
export const GM_API=  'https://fusion.gieom.com/' ;
export const GM_INSTANCE_AUTHTOKEN   =  "d0fd6067-f095-414e-8b98-750b326ef2dc" ;

/*  export const PWA_API   =  'https://mt.bankmuscat.com:5441/cc/' ;
 export const GM_API=  'https://mt.bankmuscat.com:5441/ocr/' ;
 export const GM_INSTANCE_AUTHTOKEN   =  "d0fd6067-f095-414e-8b98-750b326ef2dc";*/
export const PWA_JOURNEY_STEPS = ['general-instructions', 'scan-ID-instruction', 'instructions', 'details', 'customer-details'];
